import React from 'react'
import { useIntl } from 'react-intl'
import { middleDotSeparatorMessage } from 'LuxKit/intl/separators'
import Caption from 'LuxKit/Typography/Caption'
import Group from 'components/utils/Group'

export type LocationProps = {
  startLocation?: string | null
  endLocation?: string | null
  typeOfExperience?: string
  variant?: 'single' | 'start_and_end' | 'with_experience'
}

function TourV2Location(props: LocationProps) {
  const intl = useIntl()
  const { endLocation, startLocation, typeOfExperience, variant = 'single' } = props
  const sep = intl.formatMessage(middleDotSeparatorMessage)

  const startsEndsInLabel = intl.formatMessage(
    {
      id: 'fBeh124qft',
      defaultMessage: 'Starts in {startLocation}, Ends in {endLocation}',
      description: 'Tour location label showing distinct start and end locations',
    },
    { startLocation, endLocation },
  )

  return (
    <Group direction="horizontal" verticalAlign="center" gap={4}>
      {variant === 'single' && (
        <Caption variant="large" colour="neutral-one">
          {startLocation}
        </Caption>
      )}
      {variant === 'start_and_end' && (
        <Caption variant="large" colour="neutral-one">
          {startsEndsInLabel}
        </Caption>
      )}
      {variant === 'with_experience' && (
        <Caption variant="large" colour="neutral-one">
          {typeOfExperience
            ? intl.formatMessage({ id: 'eNQ9dtuusm', defaultMessage: '{location} {sep} {typeOfExperience}', description: 'Tour location with experience type' }, { location: startLocation, sep, typeOfExperience })
            : startLocation}
        </Caption>
      )}
    </Group>
  )
}
export default TourV2Location
